import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { PageHeader } from '@/components/ui/PageHeader'
import { useRestClient } from '@/contexts/QueryProvider'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { useParams } from 'react-router'
import { AppMarketingInfoCard } from './AppMarketingInfoCard'
import { ScrollArea } from '@/components/shadcn/scroll-area'

export function FeaturedAppDetails() {
  return (
    <QueryErrorBoundary errorMessage="Failed to fetch application details">
      <Suspense fallback={<LoadingComponent />}>
        <FeaturedAppDetailsContent />
      </Suspense>
    </QueryErrorBoundary>
  )
}

function FeaturedAppDetailsContent() {
  const { getLandingApiGetApplicationInfoExternal } = useRestClient()
  const { appId } = useParams()
  if (!appId) {
    throw new Error('App ID is required')
  }

  const { data: appDetails } = getLandingApiGetApplicationInfoExternal.useSuspenseQuery({
    path: { applicationId: Number(appId) },
  })
  return (
    <div className="px-5">
      <PageHeader title="Featured Apps">
        {/* <GridTableToggle value={view} onChange={setView} className="hidden" /> */}
      </PageHeader>

      <TablePageContainer>
        <ScrollArea className="h-full">
          <div className="py-16">
            <AppMarketingInfoCard app={appDetails} />
          </div>
        </ScrollArea>
      </TablePageContainer>
    </div>
  )
}
